module.exports = __webpack_public_path__ + "static/img/bankcard.e3b6cc3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/bankcard.gif
// module id = jSTM
// module chunks = 0